<script>
  import CircleLoader from "./CircleLoader.svelte";
  import { dataUrlToBlob } from "../utils/dataUrlToBlob.js";
  import { getBase64 } from "../utils/getBase64.js";
  import {alert} from "../store";

  export let imageUrl = null;
  export let inProgress = false;
  export let coverLabel = "Upload Image...";
  export let uploadFile = null;
  export let deleteImage = null;

  const validFiles = ['image/png', 'image/jpg', 'image/jpeg'];

  async function fileChange(e) {
    const file = e.target.files[0];
    
    if (validFiles.indexOf(file.type) === -1) {
      let error = "File type is invalid, supported formats: jpg, jpeg, png";

      alert.setWithTimeout({value: error, className: "is-danger"});
      return;
    }

    if (file.size && file.size > 1000000) {
      let error = "File size shoud be less than 1MB";

      alert.setWithTimeout({value: error, className: "is-danger"});
      return;
    }

    const dataUrl = await getBase64(file);

    const data = new FormData();
    data.append("image", dataUrlToBlob(dataUrl));

    uploadFile(data);
  }

  function deleteTheImage() {
    if (typeof deleteImage !== "function") {
      return;
    }

    deleteImage();
  }
</script>

<style>
  .image-uploader-wrapper {
    display: flex;
    justify-content: start;
    align-items: center;
  }
  .image-uploader-wrapper.inprogress {
    width: 200px;
    height: 200px;
    justify-content: center;
  }
  .file-label {
    font-size: 1rem;
  }
  .image-wrapper {
    position: relative;
  }
  .image-wrapper img {
    height: 200px;
    width: auto;
  }
  .remove-image {
    display: flex;
    position: absolute;
    width: 30px;
    height: 30px;
    justify-content: center;
    align-items: center;
    background: #00000078;
    color: #fff;
    cursor: pointer;
    border-radius: 0 0 2px 0;
  }
  .remove-image:hover {
    background: #000000e8;
  }
  .remove-image .fas {
    font-size: 0.9rem;
  }
  .is-boxed {
    min-width: 100px;
  }
</style>

<div class="field image-uploader-wrapper" class:inprogress={inProgress}>
  <div class="file is-large is-boxed has-name">

    {#if !inProgress && !imageUrl}
      <label class="file-label">
        <input
          class="file-input"
          type="file"
          accept=".png, .jpg, .jpeg"
          on:change={fileChange} />
        <span class="file-cta">
          <span class="file-icon is-small">
            <i class="fas fa-upload" />
          </span>
          <span class="file-label">{coverLabel}</span>
        </span>
      </label>
    {:else if inProgress && !imageUrl}
      <div class="is-boxed">
        <CircleLoader />
      </div>
    {:else}
      <div class="image-wrapper">
        <img src={imageUrl} alt={'image'} />
      </div>
    {/if}

    {#if imageUrl}
      <div class="remove-image" on:click={deleteTheImage}>
        <i class="fas fa-trash" />
      </div>
    {/if}
  </div>
</div>
